import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getConfiguration as getConfigurationAPI} from '../../../services/reservations'
import fixture from '../../../fixtures/reservations/get-configuration.json'

export async function getConfiguration(dispatch, {group_id}, entityObjectId = '') {
  try {
    dispatch({type: PENDING})
    let response = await getConfigurationAPI({group_id}, entityObjectId)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
